import React, { useEffect, useState } from "react";
import shape6 from "../../images/shape-6.png";
import shape24 from "../../images/shape-24.png";
import shape23 from "../../images/shape-23.png";
import shape5 from "../../images/shape-5.png";
import shape8 from "../../images/shape-8.png";
import author from "../../images/author-03.jpg";
import blog1 from "../../images/blog1.jpg";
import blog2 from "../../images/blog2.png";
import blog3 from "../../images/blog3.jpg";
import blog4 from "../../images/blog4.jpg";
import shape14 from "../../images/shape-14.png";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import books from "../../images/books.jpg";
import magnet from "../../images/magnet.jpg";

import collage from "../../images/collage.jpg";
import axios from "axios";
import call from "../../images/call.jpg";
const Blog = () => {
	const [blogs, setBlogs] = useState([]);
	const [ids, setids] = useState([]);
	const [Reload, setReload] = useState(false);
	const [Search, setSearch] = useState("");

	const navigate = useNavigate();

	function showBlog(s) {
		setids(s.id);
		console.log(s.id);
		navigate("/blog4/" + s.id);
	}
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);
	async function getBlogs() {
		let { data } = await axios.post(
			`https://maps-medics-be.onrender.com/show_blogs`,
			{ search: Search }
		);
		setBlogs(data.result);

		console.log(data.result);
	}
	useEffect(() => {
		getBlogs();
	}, [Reload]);

	return (
		<>
			{/* <Navbar/> */}
			<div className="section "></div>

			<div class="section page-banner">
				<div
					style={{
						backgroundColor: "rgba(0,0,0,0.4)",
						width: "100%",
						height: "100%",
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					}}
				>
					<div
						class="container"
						style={{
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
						}}
					>
						<div class="page-banner-content">
							{/* <ul class="breadcrumb">
                <li><a>Home</a></li>
                <li class="active">Blog</li>
            </ul> */}
							<h2 class="title" style={{ color: "#fff" }}>
								Our News And <span>Blogs.</span>
							</h2>
						</div>
					</div>
				</div>
			</div>
			<div class="section  mt-n10" style={{ paddingTop: "80px" }}>
				<div class="container">
					<div class="blog-wrapper">
						<div
							class="row p-3"
							style={{ display: "flex", justifyContent:'space-evenly'}}
						>
							<div
								class="col-lg-3 col-md-6 "
								style={{
									boxShadow: "0 2px 4px rgb(0 0 0 /8%)",
									borderRadius: "8px",
									transition: "all .3s linear",
									padding: "0",
								}}
							>
								{/* {blogs.map((p, index) => (      */}
								<Link
									to="/blog1"
									// onClick={() => showBlog(p)}
									style={{ textDecoration: "none" }}
									//   key={index}
								>
									<div class="single-blog">
										<div class="blog-image">
											<a>
												<img src={collage} alt="Blog" />
											</a>
										</div>
										<div class="blog-content">
											<div class="blog-author">
												<div class="author">
													<div class="author-name">
														<h2
															class="name"
															style={{
																color: "#ffc600",
																fontWeight: "bold",
																textDecoration: "none",
																fontSize: "22px",
																marginBottom: "18px",
																fontFamily: "Sora",
															}}
														>
															With numbers: What is the average salary and
															lifestyle of a physician in the USA?
														</h2>
													</div>
												</div>
											</div>

											<p class="title">
												<a
													style={{
														color: "#0a083b",
														padding: "20px 30px",
														fontSize: "16px",
														lineHeight: "1.815em",
														marginBottom: "20px",
														padding: "20px 30px",
													}}
												>
													With numbers: What is the average salary and lifestyle
													of a physician in the USA?
												</a>
											</p>

											<div
												style={{ display: "flex", justifyContent: "center" }}
											>
												<a
													style={{
														color: "#FFC600",
														textDecoration: "none",
														fontWeight: "600",
														fontSize: "16px",
													}}
												>
													Continue Reading →
												</a>
											</div>
										</div>
									</div>
								</Link>
								{/* ))} */}
							</div>
							{/* <div
								className="col-lg-1"
								style={{ paddingTop: "15px", width: "4%" }}
							></div> */}
							<div
								class="col-lg-3 col-md-6 "
								style={{
									boxShadow: "0 2px 4px rgb(0 0 0 /8%)",
									borderRadius: "8px",
									transition: "all .3s linear",
									padding: "0",
								}}
							>
								<Link to="/blog2" style={{ textDecoration: "none" }}>
									<div class="single-blog">
										<div class="blog-image">
											<a>
												<img src={books} alt="Blog" />
											</a>
										</div>
										<div class="blog-content">
											<div class="blog-author">
												<div class="author">
													<div class="author-name">
														<h2
															class="name"
															style={{
																color: "#ffc600",
																fontWeight: "bold",
																textDecoration: "none",
																fontSize: "22px",
																marginBottom: "18px",
																fontFamily: "Sora",
															}}
														>
															What is the USMLE?
														</h2>
													</div>
												</div>
											</div>

											<p class="title">
												<a
													style={{
														color: "#0a083b",
														padding: "20px 30px",
														fontSize: "16px",
														lineHeight: "1.815em",
														marginBottom: "20px",
														padding: "20px 30px",
													}}
												>
													What is the USMLE? The United States Medical Licensing
													Examination...
												</a>
											</p>

											<div
												style={{ display: "flex", justifyContent: "center" }}
											>
												{" "}
												<a
													style={{
														color: "#FFC600",
														textDecoration: "none",
														fontWeight: "600",
														fontSize: "16px",
														paddingBottom: "3%",
													}}
												>
													Continue Reading →
												</a>
											</div>
										</div>
									</div>
								</Link>
							</div>
							{/* <div
								className="col-lg-1"
								style={{ paddingTop: "15px", width: "4%" }}
							></div> */}
							<div
								class="col-lg-3 col-md-6"
								style={{
									boxShadow: "0 2px 4px rgb(0 0 0 /8%)",
									borderRadius: "8px",
									transition: "all .3s linear",
									padding: "0",
								}}
							>
								<Link to="/blog3" style={{ textDecoration: "none" }}>
									<div class="single-blog">
										<div class="blog-image">
											<a>
												<img src={magnet} alt="Blog" />
											</a>
										</div>
										<div class="blog-content">
											<div class="blog-author">
												<div class="author">
													<div class="author-name">
														<h2
															class="name"
															style={{
																color: "#ffc600",
																fontWeight: "bold",
																textDecoration: "none",
																fontSize: "22px",
																marginBottom: "18px",
																fontFamily: "Sora",
															}}
														>
															How to Apply for an ECFMG Certification?
														</h2>
													</div>
												</div>
											</div>
											<p class="title">
												<a
													style={{
														color: "#0a083b",
														padding: "20px 30px",
														fontSize: "16px",
														lineHeight: "1.815em",
														marginBottom: "20px",
														padding: "20px 30px",
													}}
												>
													How to Apply for an ECFMG Certification? You can
													apply...
												</a>
											</p>
											<div
												style={{ display: "flex", justifyContent: "center" }}
											>
												<a
													style={{
														color: "#FFC600",
														textDecoration: "none",
														fontWeight: "600",
														fontSize: "16px",
														paddingBottom: "3%",
													}}
												>
													Continue Reading →
												</a>
											</div>{" "}
										</div>
									</div>
								</Link>
							</div>
							{/* <div
								className="col-lg-1"
								style={{ paddingTop: "15px", width: "4%" }}
							></div> */}
							
							
							
						</div>
				
					<div className="row p-3" style={{ display: "flex", justifyContent:'space-evenly'}}>
							{blogs.map((p, index) => (
								<div
									class="col-lg-3 col-md-6"
									key={index}
									style={{
										boxShadow: "0 2px 4px rgb(0 0 0 /8%)",
										borderRadius: "8px",
										transition: "all .3s linear",
										padding: "0",
									}}
								>
									<a
										//  to='/blog3'
										onClick={() => showBlog(p)}
										style={{ textDecoration: "none" }}
									>
										<div class="single-blog">
											<div class="blog-image">
												<a>
													<img src={p.image} alt="Blog" />
												</a>
											</div>
											<div class="blog-content">
												<div class="blog-author">
													<div class="author">
														<div class="author-name">
															<h2
																class="name"
																style={{
																	color: "#ffc600",
																	fontWeight: "bold",
																	textDecoration: "none",
																	fontSize: "22px",
																	marginBottom: "18px",
																	fontFamily: "Sora",
																}}
															>
																{p.title}
															</h2>
														</div>
													</div>
												</div>
												<p class="title">
													<a
														style={{
															color: "#0a083b",
															padding: "20px 30px",
															fontSize: "16px",
															lineHeight: "1.815em",
															marginBottom: "20px",
															padding: "20px 30px",
														}}
													>
														{p.smail_text}
													</a>
												</p>
												<div
													style={{ display: "flex", justifyContent: "center" }}
												>
													<a
														style={{
															color: "#FFC600",
															textDecoration: "none",
															fontWeight: "600",
															fontSize: "16px",
															paddingBottom: "3%",
														}}
													>
														Continue Reading →
													</a>
												</div>{" "}
											</div>
										</div>
									</a>
								</div>
								
							))}
							
								</div>
					
						
							
						<div
							className="row p-3"
							style={{ display: "flex", justifyContent: "start" }}
						>
							<div
								className="col-lg-1"
								style={{ paddingTop: "15px", width: "6.5%" }}
							></div>

							{/* <div class="col-lg-3 col-md-6"  style={{boxShadow:'0 2px 4px rgb(0 0 0 /8%)', borderRadius:'8px', transition:'all .3s linear', padding:'0'}}>

       <Link to='/blog4' style={{textDecoration:'none'}}>
       <div class="single-blog">
    <div class="blog-image">
        <a ><img src={magnet} alt="Blog"/></a>
    </div>
    <div class="blog-content">
        <div class="blog-author">
            <div class="author">
             
                <div class="author-name">
                    <h2 class="name" style={{color:'#ffc600', fontWeight:'bold' , textDecoration:'none', fontSize:'22px', marginBottom:'18px', fontFamily:'Sora'}}>How to Apply for an ECFMG Certification?</h2>
                </div>
            </div>
      
        </div>

        <p class="title"><a style={{color:'#0a083b', padding:'20px 30px' , fontSize:'16px', lineHeight:'1.815em', marginBottom:'20px', padding:'20px 30px'}} >How to Apply for an ECFMG Certification? You can apply...</a></p>

     
        <div style={{display:'flex', justifyContent:'center'}}>

        <a style={{color:'#FFC600', textDecoration:'none', fontWeight:'600', fontSize:'16px', paddingBottom:'3%'}}>Continue Reading →</a>
        </div>  </div>
</div>
       </Link>                  


</div> */}
						</div>
					</div>
				</div>
			</div>
			<div class="section section-padding ">
				<div className="container">
					<div className="row">
						<div className="col-md-12">
							<div className="row">
								<label htmlFor="">Search</label>
							</div>
							<div className="row">
								<div className="col-md-6 p-3">
									<input
										type="text"
										className="form-control"
										onChange={(e) => setSearch(e.target.value)}
									/>
								</div>
								<div className="col-md-6 p-3">
									<button
										class="btn btn-primary "
										style={{
											backgroundColor: "#FFC600",
											border: "#FFC600",
											borderRadius: "20px",
										}}
										onClick={() => {
											setReload(!Reload);
										}}
									>
										Search
									</button>
								</div>
							</div>
						</div>
					</div>
					<div className="row">
						<div className="col-md-12">
							<h2
								style={{
									fontSize: "48px",
									color: "#383838",
									lineHeight: "2em",
									fontWeight: "700",
									fontFamily: "Sora",
								}}
							>
								Recent Comments
							</h2>
							<div>No Comments to show.</div>
						</div>
					</div>
				</div>

				{/* <div class="app-shape-1"></div>
<div class="app-shape-2"></div>
<div class="app-shape-3"></div>
<div class="app-shape-4"></div>

<div class="container">

    <div class="download-app-wrapper mt-n6">

        <div class="section-title section-title-white">
            <h3 class="sub-title">Recent Posts</h3>
            <p class="main-title" style={{fontSize:'18px'}}><i class="fa-solid fa-chevron-right" style={{color:'#FFC600', marginRight:'5px'}}></i>With numbers: What is the average salary and lifestyle of a physician in the USA?</p>
            <p class="main-title" style={{fontSize:'18px'}}><i class="fa-solid fa-chevron-right" style={{color:'#FFC600', marginRight:'5px'}}></i>Average COMLEX® Match Scores by Medical Specialty 2022</p>
            <p class="main-title" style={{fontSize:'18px'}}><i class="fa-solid fa-chevron-right" style={{color:'#FFC600', marginRight:'5px'}}></i>USMLE® Step 1 Exam Dates in 2023: What You Need to Know</p>
            <p class="main-title" style={{fontSize:'18px'}}><i class="fa-solid fa-chevron-right" style={{color:'#FFC600', marginRight:'5px'}}></i>Preparing for the USMLE® Step 1 as a Pass/Fail Exam</p>


        </div>

        <img class="shape-1 animation-right" src={shape14} alt="Shape"/>

        <div class="download-app-btn">
        <h3 class="sub-title" style={{color:'#fff'}}>Recent Comments</h3>
        <p class="main-title" style={{fontSize:'18px',color:'#fff'}}><i class="fa-solid fa-chevron-right" style={{color:'#FFC600', marginRight:'5px'}}></i>No comments to show.</p>

        </div>

    </div>
  

</div> */}
			</div>
			{/* <Footer/> */}
		</>
	);
};

export default Blog;
